import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	updatedJobList: [],
	isActive: true,
};

const jobListSlice = createSlice({
	name: "jobListSlice",
	initialState: initialState,
	reducers: {
		setUpdatedJobList(state, action) {
			state.updatedJobList = action.payload;
		},
	},
});

export const JobListActions = jobListSlice.actions;
export default jobListSlice.reducer;
